module.exports = __webpack_public_path__ + "static/media/Nota Fiestas Navideñas.2e846347.webp";